module.exports = __webpack_public_path__ + "img/info-custom.9c9445d7.svg";